import type { VersionedData } from '../shared/VersionedData';
import { EmotionalState } from './enums';

/**
 * Payload carried by one day's EmotionalProtocolLog. No state declared is a valid, default
 * outcome — the normal mode is never conflated with the joie state.
 */
export interface EmotionalStateContent {
  readonly state: EmotionalState | null;
}

export const DEFAULT_EMOTIONAL_STATE_CONTENT: EmotionalStateContent = { state: null };

const CONTENT_VERSION = 1;

export function toEmotionalStateData(content: EmotionalStateContent): VersionedData {
  return { version: CONTENT_VERSION, payload: { ...content } };
}

function isEmotionalStateOrNull(value: unknown): value is EmotionalState | null {
  return value === null || Object.values(EmotionalState).includes(value as EmotionalState);
}

/** Returns undefined for missing, malformed or future-versioned payloads rather than throwing. */
export function fromEmotionalStateData(
  data: VersionedData | undefined,
): EmotionalStateContent | undefined {
  if (!data || data.version !== CONTENT_VERSION) return undefined;
  const { state } = data.payload;
  if (!isEmotionalStateOrNull(state)) return undefined;
  return { state };
}
